import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import CategoryTag from '@atlassian/jira-business-categories/src/ui/category-form/category-tag/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { categoryGroupHeader_issueTableGrouping$key } from '@atlassian/jira-relay/src/__generated__/categoryGroupHeader_issueTableGrouping.graphql';
import messages from './messages.tsx';

export type Props = {
	categoryGroupHeader: categoryGroupHeader_issueTableGrouping$key | null;
};

export const CategoryGroupHeader = ({ categoryGroupHeader }: Props) => {
	const data = useFragment<categoryGroupHeader_issueTableGrouping$key>(
		graphql`
			fragment categoryGroupHeader_issueTableGrouping on JiraJqlOptionFieldValue {
				displayName
				option {
					color {
						colorKey
					}
				}
			}
		`,
		categoryGroupHeader,
	);

	const { formatMessage } = useIntl();

	return data != null ? (
		<CategoryTag
			categoryColor={data?.option?.color?.colorKey ?? null}
			categoryName={data?.displayName}
			isInteractive={false}
		/>
	) : (
		<Text>{formatMessage(messages.noCategory)}</Text>
	);
};
